import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgRightArrow2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 91 51"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      fill="currentColor"
      d="M63.004.003a3 3 0 0 0-1.875 5.219L79.44 22.034H3.16a3 3 0 0 0-.313 0c-1.57.082-2.925 1.585-2.843 3.156s1.585 2.926 3.156 2.844H79.44L61.129 44.815a3 3 0 1 0 4.062 4.407l24-22a3 3 0 0 0 0-4.407l-24-22a3 3 0 0 0-2.187-.812"
    />
  </svg>
);
